import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/free-solid-svg-icons';

function IconFA({ iconName, fontSize = '30px', color = '#000', onClick }) {
    // Dynamisches Icon basierend auf dem Namen abrufen
    const icon = Icons[`fa${iconName.charAt(0).toUpperCase()}${iconName.slice(1)}`];

    if (!icon) {
        console.error(`Icon "${iconName}" nicht gefunden.`);
        return null; // Fallback, falls das Icon nicht existiert
    }

    const style = {
        fontSize,
        color,
    };

    return <FontAwesomeIcon onClick={onClick} icon={icon} style={style} />;
}

export default IconFA;